import { render, staticRenderFns } from "./activationAdviser.vue?vue&type=template&id=50cf81e8&scoped=true"
import script from "./activationAdviser.vue?vue&type=script&lang=js"
export * from "./activationAdviser.vue?vue&type=script&lang=js"
import style0 from "./activationAdviser.vue?vue&type=style&index=0&id=50cf81e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf81e8",
  null
  
)

export default component.exports